/** Full legal / footer name */
export const SITE_FULL_NAME = 'The Bridge- Wellness & Therapy Center';
/** Short name for headlines — “Welcome to The Bridge” */
export const SITE_NAME = 'The Bridge';
/** Wordmark subtitle line */
export const SITE_TITLE = 'Wellness & Therapy Center';
/** Display name for headlines */
export const SITE_PRACTITIONER_NAME = 'Lisa J. Norman';
/** Full line wherever name and credentials appear together */
export const SITE_PRACTITIONER_CREDENTIALS =
  'Lisa J. Norman M.A. LMFT Associate Supervised by Russ Bartee #2773';
/** Practitioner title line (About page, etc.) */
export const SITE_PRACTITIONER_TITLE = 'Licensed Therapist';
/** Professional credential shorthand */
export const SITE_NAME_CREDENTIALS = 'M.A. LMFT Associate';

/** About — credentials */
export const SITE_PRACTICE_LOCATION = 'DFW, Texas';
/** Supervisor license number (Russ Bartee) */
export const SITE_SUPERVISOR_NAME = 'Russ Bartee';
export const SITE_SUPERVISOR_LICENSE = '2773';
/** Supervisor line — split display (connect card, etc.) */
export const SITE_SUPERVISION_LINE = `Supervised by ${SITE_SUPERVISOR_NAME} #${SITE_SUPERVISOR_LICENSE}`;
/** e.g. "123456" — display as "License #123456" */
export const SITE_LMFT_LICENSE_NUMBER = '';
/** e.g. "M.A. in Marriage & Family Therapy" */
export const SITE_MFT_DEGREE = 'M.A. in Marriage & Family Therapy';
export const SITE_MFT_SCHOOL = 'Amberton University';
/** Year Lisa completed her M.A. program */
export const SITE_MFT_GRADUATION_YEAR = '2023';
/** Year Lisa earned Texas LMFT license (e.g. "2026") */
export const SITE_LMFT_LICENSE_YEAR = '2026';
/** Years in salon / stylist career — life experience, not licensed practice */
export const SITE_SALON_YEARS = '35+';
/** Upper arc on circular seal — all caps */
export const SITE_BRAND_SEAL_TOP_ARC = 'THE BRIDGE';
/** Lower arc on circular seal — all caps */
export const SITE_BRAND_SEAL_BOTTOM_ARC = 'WELLNESS & THERAPY CENTER';
/** Hero / intro three-word tagline — one underline per word */
export const SITE_HERO_TAGLINE = ['Heal', 'Grow', 'Thrive'] as const;
/** Home hero kicker (mockup) */
export const SITE_HERO_KICKER = 'From where you are';
/** Home hero headline (mockup) */
export const SITE_HERO_HEADLINE = 'to Where You Want to Be';
/** Home hero lead paragraph */
export const SITE_HERO_LEAD =
  'At The Bridge- Wellness & Therapy Center, we help individuals, couples, and families navigate life\u2019s challenges with clarity, compassion, and support.';
export const SITE_EMAIL_DISPLAY = 'support@lisanormantherapy.com';
export const SITE_EMAIL_MAILTO = 'mailto:support@lisanormantherapy.com';
export const SITE_PHONE_DISPLAY = '(945) 232-4830';
export const SITE_PHONE_TEL = '9452324830';
export const SITE_LOCATION_DISPLAY = 'DFW, Texas';
export const SITE_ABOUT_LEAD_PLACEHOLDER =
  "I'm glad you're here. My practice is built for real life—for individuals carrying stress or anxiety, couples who feel stuck, and families who want to understand each other again. I bring a calm, structured space where we can name what's hard, strengthen what matters, and move at a pace that honors your story.";
